require('./brokerProductFileTab.scss');

const PropTypes = require('prop-types');

const React = require('react');
const { Component } = require('react');
const iframeResizer = require('iframe-resizer');
const { getLanguage } = require('core/i18n').i18n;

class DetailsTab extends Component {

    componentDidMount() {
        iframeResizer.iframeResizer();
    }

    render() {
        const { isin, iso } = this.props.details;
        let language = getLanguage();
        language = language !== 'en' ? 'es' : language;
        const iframeUrl = `https://openbank-analisis.webfg.com/fichaValor/${iso}/${isin}/${language}`;

        return (
            <div className="broker-product-file-tab">
                <iframe
                    className="broker-product-file-tab__iframe"
                    src={iframeUrl}
                />
            </div>
        );
    }
}

DetailsTab.propTypes = {
    details: PropTypes.object.isRequired
};

module.exports = DetailsTab;